<template>
    <div>
        <PageHeader>
            <template #navbar>
                <Navbar />
            </template>
            <template #pagetitle>
                <PageTitle :pageTitle="$t('pages.titles.newsDetail')" />
            </template>
        </PageHeader>
        <SingleCasesStudyFour />
        <FreeTrial variant="light"/>
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageHeader from '../Layout/PageHeader'
import PageTitle from '../Common/PageTitle'
import SingleCasesStudyFour from '../SingleCasesStudy/SingleCasesStudyFour'
import FreeTrial from '../Common/FreeTrial'
import Footer from '../Layout/Footer'

export default {
    name: 'SingleNewsFourPage',
    components: {
        Navbar,
        PageHeader,
        PageTitle,
        SingleCasesStudyFour,
        FreeTrial,
        Footer,
    }
}
</script>
